import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import HeaderBar from "./HeaderBar";
import LeftDrawer from "./LeftDrawer";
import RightDrawer from "./RightDrawer";

import { Colors } from "../utils/Colors";

export default function AppLayout() {
  const [leftOpen, setLeftOpen] = React.useState(false);
  const [rightOpen, setRightOpen] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: Colors.bg.app }}>
      <HeaderBar
        onOpenLeft={() => setLeftOpen(true)}
        onOpenRight={() => setRightOpen(true)}
      />

      <Box sx={{ p: 2.5 }}>
        <Outlet />
      </Box>

      <LeftDrawer
        open={leftOpen}
        onClose={() => setLeftOpen(false)}
        currentPath={location.pathname}
        onNavigate={(path) => {
          navigate(path);
          setLeftOpen(false);
        }}
      />

      <RightDrawer
        open={rightOpen}
        onClose={() => setRightOpen(false)}
      />
    </Box>
  );
}